module.exports = __webpack_public_path__ + "static/media/doctorOutside.87283429.png";